// Action types for the Extensions slice. Workers owned by the legacy extensions page stay
// on `apps/*` — see docs/chat-features-migration/PARITY-AUDIT.md §8.1.
const actions = {
  SET_STATE: 'extensions/SET_STATE',
  EXTENSIONS_LIST: 'extensions/EXTENSIONS_LIST',
  ENABLE_DISABLE_EXTENSION: 'extensions/ENABLE_DISABLE_EXTENSION',
  UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT:
    'extensions/UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT',
} as const

export default actions
